import { createFileRoute } from '@tanstack/react-router';
import { APP_PATHS, PAGE_PATHS, Permission, PermissionEntitiesNames } from '../../../../../../../../types';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/incidents/settings/rule-set/$id/audit/')({
  beforeLoad: ({ context, preload }) => {
    const isAllowed =
      !!context.userPermissions.hasAllowedPermission({ path: PAGE_PATHS.RULE_SET, app: APP_PATHS.INCIDENTS }) &&
      !!context.userPermissions.hasAllowedPermissionToResource({
        resource: PermissionEntitiesNames.ACCOUNT,
        permission: Permission.UPDATE,
      });
    context.validatePermissions({ isAllowed, preload });
  },
});
